import { env } from '@/env'
import { api } from '@/services/fintalk/api'

import { type AuthTokens } from './types'

export interface SsoLoginParams {
  token: string
  legacy: boolean
}

export async function ssoLogin({
  token,
  legacy,
}: SsoLoginParams): Promise<AuthTokens> {
  const resp = await api.post<AuthTokens>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    '/sso/login',
    {
      body: { token, legacy },
    },
  )

  return resp.body
}
